import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import Seo from '../components/Seo';
import Reveal from '../components/Reveal';
import { T } from '../i18n/copy';
import { homePath } from '../i18n/paths';

export default function ReceivedPage({ lang }) {
  const t = T.received;
  return (
    <>
      <Seo lang={lang} title={T.meta.received.title[lang]} description={T.meta.received.desc[lang]} />
      <section data-header-theme="bone" data-testid="received-page" className="editorial-margins bg-bone py-16 md:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-vermilion"
            data-testid="received-check"
          >
            <Check className="h-6 w-6 text-vermilion" strokeWidth={1.5} />
          </motion.div>
          <Reveal delay={0.1}>
            <h1 className="mt-8 font-tight font-semibold text-[clamp(2rem,4vw,3.4rem)] leading-[1.06] tracking-[-0.02em] text-midnight" data-testid="received-headline">
              {t.headline[lang]}
            </h1>
          </Reveal>
          <Reveal delay={0.16} className="mt-8 space-y-4 text-base leading-relaxed text-midnight/70">
            <p>{t.body1[lang]}</p>
            <p>{t.body2[lang]}</p>
            <p>{t.body3[lang]}</p>
          </Reveal>
          <Reveal delay={0.22} className="mt-12">
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border border-midnight/15 bg-bone px-6 py-4" data-testid="received-flow">
              {t.flow[lang].map((w, i) => (
                <span key={w} className="flex items-center gap-3">
                  <span className="eyebrow text-midnight/70">{w}</span>
                  {i < t.flow[lang].length - 1 && <ArrowRight className="h-3 w-3 text-vermilion" strokeWidth={1.5} />}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.28} className="mt-12">
            <Link
              to={homePath(lang)}
              data-testid="received-return-button"
              className="inline-flex items-center gap-3 bg-vermilion px-7 py-4 text-[13px] font-medium tracking-[0.06em] text-bone transition-colors duration-300 hover:bg-[#A8402C]"
            >
              {t.cta[lang]}
              <ArrowRight className="h-4 w-4" strokeWidth={2} />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
